import { OrderBy, Periods } from "@hometoq/backend/enums";
import { z } from "zod/v4";

export const searchSchema = z.object({
  city: z.string().optional(),
  date: z.string().optional(),
  period: z.enum(Periods).optional(),
  orderBy: z.enum(OrderBy).optional(),
  minPrice: z.number().optional(),
  maxPrice: z.number().optional(),
  chefName: z.string().optional(),
  tags: z.array(z.string()).optional(),
  page: z.number().optional().catch(1),
});

export type SearchParams = z.infer<typeof searchSchema>;
